import type { parsers } from "@fraction/shared";
import { useQuery } from "@tanstack/react-query";
import { useFractionClient } from "./FractionClientContext";

/**
 * Fetch the lender rate cards. Shared by web + mobile. Persistence (web) is
 * handled at the QueryClient level, so a plain useQuery here keeps the same
 * behaviour; `staleTime: 0` + `refetchOnMount: "always"` mirrors the old web
 * `useCachedQuery({ initialRefetch: true })`.
 */
export function useRates(options?: parsers.rate.FetchRateArgs) {
  const client = useFractionClient();
  return useQuery({
    queryKey: ["rates"],
    staleTime: 0,
    refetchOnMount: "always",
    queryFn: () => client.getRates(options),
  });
}
